import { DateRangeReq } from "@gtpl/shared-models/analytics-data";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { EnquiryLifecycleStatusEnum } from "@gtpl/shared-models/enquiry-management";

import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import appSettings from "apps/services/config";
import { getManager } from "typeorm";
import { ProductionProcessDashboardReq } from "@gtpl/shared-models/production-management";
import moment from "moment";
import { RmReceivingDashReq, RmReceivingReportReq } from "@gtpl/shared-models/procurement-management";
import { CommonResponse as Response } from '@gtpl/shared-models/sale-management';

@Injectable()
export class MainDashboardService {
    constructor(){}

    async getEnquiresStatusWiseCount(req:DateRangeReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let resData:any[] =[];
            let totalEnquires = 0;
            for(let data of Object.values(EnquiryLifecycleStatusEnum).sort()){
                let status = data;
                    let info;
                if(data === EnquiryLifecycleStatusEnum.REJECTED){
                    info = `select life_cycle_status AS status, enquiry_reject_description AS reason, count(enquiry_id) AS cnt from `+appSettings.enquiry_db+`.enquiries where life_cycle_status= '${data}' `;
                    if(req.fromDate != undefined && req.toDate != undefined){
                        info = info + ` and enquiry_date between "${req.fromDate}" and "${req.toDate}" `
                    }
                    info = info + `group by enquiry_reject_description order by enquiry_reject_description`;
                }
                else{
                    info = `select life_cycle_status AS status, count(enquiry_id) AS cnt from `+appSettings.enquiry_db+`.enquiries where life_cycle_status= '${data}' `;
                    if(req.fromDate != undefined && req.toDate != undefined){
                        info = info + ` and enquiry_date between "${req.fromDate}" and "${req.toDate}" `
                    }
                    info = info + `group by life_cycle_status order by life_cycle_status`;
                }
                const getInfo =await manager.query(info)
                console.log(getInfo)
                if(getInfo.length > 0){
                    if(data === EnquiryLifecycleStatusEnum.REJECTED){
                        resData.push({"Rejected": getInfo});
                        const rejectCount = getInfo.reduce((sum, row) => sum + Number(row.cnt), 0);
                        totalEnquires += rejectCount;
                    }else{
                        resData.push(getInfo[0]);
                        totalEnquires += Number(getInfo[0].cnt);
                    }
                }else{
                    resData.push({"status": status,"cnt": 0});
                }
                
            }
            resData.push({"status":"Total Enquiries","cnt":totalEnquires});

            if(resData.length > 0){
                return new CommonResponse(true,1,'Data retreievd',resData)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

async getRawMaterialInward(req: DateRangeReq): Promise<CommonResponse> {
    try {
        const manager = getManager();

        let query = `
            SELECT 
                SUM(qty) AS qty,
                SUM(value) AS value
            FROM (

                SELECT 
                    IF(gi.reweighment_quantity > 0, gi.reweighment_quantity, gi.quantity) AS qty,
                    ri.total_amount AS value
                FROM ${appSettings.rm_procure_db}.grn_items gi
                LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri 
                    ON ri.grn_item_id = gi.grn_item_id
                WHERE gi.grn_item_id > 0
                AND gi.broker > 0
        `;

        if (req.fromDate && req.toDate) {
            query += ` AND DATE(gi.reweighment_date) 
                       BETWEEN "${req.fromDate}" AND "${req.toDate}" `;
        }

        query += `
                UNION ALL
                SELECT
                    IF(gi.reweighment_quantity > 0, gi.reweighment_quantity, gi.quantity) AS qty,
                    ri.total_amount AS value
                FROM ${appSettings.rm_procure_db}.grn_items gi
                LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri 
                    ON ri.grn_item_id = gi.grn_item_id
                WHERE gi.grn_item_id > 0
                AND gi.farmer > 0
        `;

        if (req.fromDate && req.toDate) {
            query += ` AND DATE(gi.reweighment_date) 
                       BETWEEN "${req.fromDate}" AND "${req.toDate}" `;
        }

        query += `
            ) AS combined_totals;
        `;

        const getInfo = await manager.query(query);

        if (getInfo.length > 0 && getInfo[0].qty > 0) {
            return new CommonResponse(true, 1, 'Data retrieved', [getInfo[0]]);
        } else {
            return new CommonResponse(false, 0, 'No data found');
        }

    } catch (err) {
        throw err;
    }
}



    async getSupplierValueWiseDate(req:DateRangeReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query1 = `Select IF(gi.reweighment_count > 0, gi.reweighment_count, gi.count) AS count,gi.broker,sb.supplier_id,sb.code,sb.name AS supplier_name,SUM(IF(reweighment_quantity > 0, reweighment_quantity, gi.quantity)) AS qty, SUM(ri.total_amount) AS value from ${appSettings.rm_procure_db}.grn_items gi `;
            query1 = query1 + ` left join ${appSettings.rm_procure_db}.grn g on g.grn_id = gi.grn_id left join ${appSettings.rm_procure_db}.rm_invoice ri on ri.grn_item_id = gi.grn_item_id left join ${appSettings.masters_db}.suppliers sb on sb.supplier_id = gi.broker left join ${appSettings.rm_procure_db}.indent i on i.indent_id = gi.indent_id where gi.grn_item_id > 0 and gi.broker > 0 and gi.broker is not null `
            if(req.fromDate != undefined && req.toDate != undefined){
                query1 = query1 + ` and Date(gi.reweighment_date) between "${req.fromDate}" and "${req.toDate}" `
            }
            if(req.supplierId != undefined){
                query1 = query1 + ` and gi.broker = ${req.supplierId} `
            }

            if(req.gradeMinCount > 0 && req.gradeMaxCount > 0){
                query1 = query1 + ` and IF(gi.reweighment_count > 0, gi.reweighment_count, gi.count) between  ${req.gradeMinCount} and ${req.gradeMaxCount}`
            }

            query1 = query1 + ` group by gi.broker,IF(gi.reweighment_count > 0, gi.reweighment_count, gi.count) order by sb.name, IF(gi.reweighment_count > 0, gi.reweighment_count, gi.count) `

            const getInfo1 =await manager.query(query1);

            let query2 = `Select IF(gi.reweighment_count > 0, gi.reweighment_count, gi.count) AS count,sf.supplier_id, sf.code,sf.name AS supplier_name, SUM(IF(reweighment_quantity > 0, reweighment_quantity, gi.quantity)) AS qty, SUM(ri.total_amount) AS value from ${appSettings.rm_procure_db}.grn_items gi `;
            query2 = query2 + ` left join ${appSettings.rm_procure_db}.grn g on g.grn_id = gi.grn_id left join ${appSettings.rm_procure_db}.rm_invoice ri on ri.grn_item_id = gi.grn_item_id left join ${appSettings.masters_db}.suppliers sf on sf.supplier_id = gi.farmer left join ${appSettings.rm_procure_db}.indent i on i.indent_id = gi.indent_id where gi.grn_item_id > 0 and  gi.farmer > 0 and gi.farmer is not null `
            if(req.fromDate != undefined && req.toDate != undefined){
                query2 = query2 + ` and Date(gi.reweighment_date) between "${req.fromDate}" and "${req.toDate}" `
            }
            if(req.supplierId != undefined){
                query2 = query2 + ` and gi.farmer = ${req.supplierId} `
            }

            if(req.gradeMinCount > 0 && req.gradeMaxCount > 0){
                query2 = query2 + ` and IF(gi.reweighment_count > 0, gi.reweighment_count, gi.count) between  ${req.gradeMinCount} and ${req.gradeMaxCount} `
            }

            query2 = query2 + ` group by gi.farmer,IF(gi.reweighment_count > 0, gi.reweighment_count, gi.count) order by sf.name, IF(gi.reweighment_count > 0, gi.reweighment_count, gi.count) `

            const getInfo2 =await manager.query(query2);
            let data = [...getInfo1,...getInfo2]
            console.log(data);
            if(data.length > 0){
                return new CommonResponse(true,1,'Data retreievd',data)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getMonthWiseSaleOrders(req:DateRangeReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            // let months:any[] = [{"jan":1},{"feb":2},{"mar":3},{"Apr":4},{"may":5},{"jun":6},{"jul":7},{"aug":8},{"sep":9},{"oct":10},{"nov":11},{"dec":12}];
            let months = [1,2,3,4,5,6,7,8,9,10,11,12];
            let accepted:any = []
            let pending:any = []
            let open:any = []
            let close:any = []
            let cancel:any = []

            for(let res of months){
                console.log(res);
                let query1 = `select count(inv_details_id) AS count from ${appSettings.sales_db}.so_invoice_details sid left join ${appSettings.sales_db}.sale_order s on s.sale_order_id = sid.sale_order_id where (Month(act_edl_date) = ${res} and Year(act_edl_date) = ${req.year}) and sid.sale_order_id > 0 and s.life_cycle_status != "Closed" `;
                // if(req.fromDate != undefined && req.toDate != undefined){
                //     query1= query1+ ` and Date(sid.act_edl_date) between "${req.fromDate}" and "${req.toDate}" `
                // }
                if(req.buyerId != undefined){
                    query1= query1+ ` and sid.end_customer_id = ${req.buyerId} `
                }
                const pendingSOs =await manager.query(query1);
                let query = `select count(inv_details_id) AS count from ${appSettings.sales_db}.so_invoice_details sid left join ${appSettings.sales_db}.sale_order s on s.sale_order_id = sid.sale_order_id where (Month(act_edl_date) = ${res} and Year(act_edl_date) = ${req.year}) and sid.sale_order_id > 0 `;
                // if(req.fromDate != undefined && req.toDate != undefined){
                //     query = query + ` and Date(sid.act_edl_date) between "${req.fromDate}" and "${req.toDate}" `
                // }
                if(req.buyerId != undefined){
                    query= query+ ` and sid.end_customer_id = ${req.buyerId} `
                }
                const acceptedSOs =await manager.query(query);
                console.log(acceptedSOs);
                console.log(pendingSOs);

                console.log(acceptedSOs[0].count);
                console.log(pendingSOs[0].count);

                let openQuery = `select count(s.sale_order_id) AS count from ${appSettings.sales_db}.so_invoice_details sid left join ${appSettings.sales_db}.sale_order s on s.sale_order_id = sid.sale_order_id where (Month(sid.created_at) = ${res} and Year(sid.created_at) = ${req.year}) and sid.sale_order_id > 0 and s.status IN ('OPEN','INPROGRESS','PARTIALPO') `;
                
                if(req.buyerId != undefined){
                    openQuery= openQuery+ ` and sid.end_customer_id = ${req.buyerId} `
                }
                const openSOsresult =await manager.query(openQuery);

                let closeQuery = `select count(s.sale_order_id) AS count from ${appSettings.sales_db}.so_invoice_details sid left join ${appSettings.sales_db}.sale_order s on s.sale_order_id = sid.sale_order_id where (Month(sid.created_at) = ${res} and Year(sid.created_at) = ${req.year}) and sid.sale_order_id > 0 and s.status = 'CLOSED' `;
                
                if(req.buyerId != undefined){
                    closeQuery= closeQuery+ ` and sid.end_customer_id = ${req.buyerId} `
                }
                const closeSOsresult =await manager.query(closeQuery);

                let cancelQuery = `select count(s.sale_order_id) AS count from ${appSettings.sales_db}.so_invoice_details sid left join ${appSettings.sales_db}.sale_order s on s.sale_order_id = sid.sale_order_id where (Month(sid.created_at) = ${res} and Year(sid.created_at) = ${req.year}) and sid.sale_order_id > 0 and s.status = 'CANCELLED' `;
                
                if(req.buyerId != undefined){
                    cancelQuery= cancelQuery+ ` and sid.end_customer_id = ${req.buyerId} `
                }
                const cancelSosresult =await manager.query(cancelQuery);

                if(acceptedSOs[0].count > 0){
                    accepted.push(acceptedSOs[0].count);
                }
                else{
                    accepted.push(0)
                }
                if(pendingSOs[0].count > 0){
                    pending.push(pendingSOs[0].count);
                }
                else{
                    pending.push(0)
                }

                if(openSOsresult[0].count > 0){
                    open.push(openSOsresult[0].count);
                }
                else{
                    open.push(0)
                }
                if(closeSOsresult[0].count > 0){
                    close.push(closeSOsresult[0].count);
                }
                else{
                    close.push(0)
                }
                if(cancelSosresult[0].count > 0){
                    cancel.push(cancelSosresult[0].count);
                }
                else{
                    cancel.push(0)
                }
            }
            console.log(accepted);
            console.log(pending);
            return new CommonResponse(true,1,'Data retreievd',[{"Total Accepted":accepted},{"Total Pending":pending},{"Open":open},{"Close":close},{"Cancel":cancel}])
           
        }catch(err){
            throw err
        }
    }

    async getOverDueSaleOrders(req:DateRangeReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
                let query1 = `select count(inv_details_id) AS count from ${appSettings.sales_db}.so_invoice_details sid where sale_order_id > 0 `;
                if(req.fromDate != undefined && req.toDate != undefined){
                    query1= query1+ ` and Date(sid.act_edl_date) between "${req.fromDate}" and "${req.toDate}" `
                }
                const overdue =await manager.query(query1);
            if(overdue[0].count > 0){
                return new CommonResponse(true,1,'Data retreievd',overdue)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getStockCount(req:DateRangeReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
                let query1 = `SELECT reporting_date,SUM(IF(pm.uom_id = 1,reported_cases*no_of_pouches*pouches_per_row,IF(pm.uom_id = 2,(reported_cases*no_of_pouches*pouches_per_row)*0.453592, IF(pm.uom_id = 3, (reported_cases*no_of_pouches*pouches_per_row)*0.0283495,IF(pm.uom_id = 4, (reported_cases*no_of_pouches*pouches_per_row)*0.001,reported_cases*no_of_pouches*pouches_per_row))))) AS cases,SUM(loose_pouches) AS loosePouches FROM ${appSettings.warehouse_db}.reporting r left join ${appSettings.masters_db}.packing_methods pm on pm.packing_method_id = r.pack_style_id where r.reporting_log_id > 0 `;
                if(req.fromDate != undefined && req.toDate != undefined){
                    query1= query1+ ` and reporting_date between "${req.fromDate}" and "${req.toDate}" `
                }
                const stockInCount =await manager.query(query1);

                let query2 = `SELECT f.DATE,SUM(IF(pm.uom_id = 1,job_cartons*no_of_pouches*pouches_per_row,IF(pm.uom_id = 2,(job_cartons*no_of_pouches*pouches_per_row)*0.453592, IF(pm.uom_id = 3, (job_cartons*no_of_pouches*pouches_per_row)*0.0283495,IF(pm.uom_id = 4, (job_cartons*no_of_pouches*pouches_per_row)*0.001,job_cartons*no_of_pouches*pouches_per_row))))) AS cases,SUM(job_loose_pouches) AS loosePouches FROM ${appSettings.warehouse_db}.fork_lift_items fi left join ${appSettings.warehouse_db}.fork_lift_jobs f on f.job_id = fi.fork_lift_job_id left join ${appSettings.warehouse_db}.stock s on s.stock_id = fi.stock_id left join ${appSettings.masters_db}.packing_methods pm on pm.packing_method_id = s.pack_style_id where f.job_id > 0 `;
                if(req.fromDate != undefined && req.toDate != undefined){
                    query2= query2+ ` and f.date between "${req.fromDate}" and "${req.toDate}" `
                }
                const stockOutCount =await manager.query(query2);

            if(stockInCount[0].cases > 0){
                return new CommonResponse(true,1,'Data retreievd',[{"stockInQty":{"cases":stockInCount[0].cases,"loosePouches":stockInCount[0].loosePouches}},{"stockOutQty":{"cases":stockOutCount[0].cases,"loosePouches":stockOutCount[0].loosePouches}}])
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getDetailStock():Promise<CommonResponse>{
        try{
            const manager = getManager()
                let query1 = `SELECT pm.packing_method_name AS packStyle,s.transaction_type AS transactionType,sid.po_number AS poNo, short_code AS NAME,CONCAT(min_grade,"-",max_grade) AS grade, SUM(total_cartons) AS COUNT, SUM(s.loose_pouches) AS loosePouches FROM ${appSettings.warehouse_db}.stock s LEFT JOIN ${appSettings.masters_db}.sku_codes sk ON sk.sku_code_id = s.varient_id left join ${appSettings.masters_db}.packing_methods pm on pm.packing_method_id = s.pack_style_id left join ${appSettings.sales_db}.so_invoice_details sid on sid.sale_order_id = s.sale_order_id where s.total_cartons > 0 GROUP BY s.transaction_type,sid.po_number,short_code,min_grade,max_grade order by s.transaction_type,sid.po_number,short_code,min_grade,max_grade `;
                const result =await manager.query(query1);

            if(result.length > 0){
                return new CommonResponse(true,1,'Data retreievd',result)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getTotalProductionForDashboard(req?: ProductionProcessDashboardReq): Promise<CommonResponse> {
        console.log("req");
        console.log(req);

        const manager = getManager();
        req.date = moment(req.date).format('YYYY-MM-DD');
    
const query = `
    SELECT r.reporting_log_id, DATE(r.reporting_date) AS reportingDate, r.variant_id, 
           r.reported_cases AS cases, r.loose_pouches AS loosePouches, r.pack_style_id, 
           sku.short_code, pm.packing_method_name, pm.pouches_per_row AS pouchWeight, 
           uom.uom_name AS uomName, pm.gross_weight AS grossWeight,vfi.code AS valueFiveCode
    FROM erpx_dev_warehouse.reporting r
    LEFT JOIN erpx_dev_masters.sku_codes sku ON sku.sku_code_id = r.variant_id
    LEFT JOIN erpx_dev_masters.packing_methods pm ON pm.packing_method_id = r.pack_style_id
    LEFT JOIN erpx_dev_masters.uoms uom ON uom.uom_id = pm.uom_id
    LEFT JOIN erpx_dev_masters.value_addition_five_types vfi ON vfi.value_addition_five_id = sku.value_addition_five_id
    WHERE r.reporting_log_id > 0 
      AND DATE(r.reporting_date) = '${req.date}' 
      AND r.transaction_type IN ('reprocessing', 'rm');
`;

    
        const data = await manager.query(query);
        console.log(data)
        if (!Array.isArray(data) || data.length === 0) {
            return new CommonResponse(false, 0, "No Data Found", []);
        }
    
        let totalSlabs = 0;
        let totalKgs = 0;
        let totalGrossWeight = 0;
    
        const processedData = data.map((row: any) => {
            let conversionFactor = 1;
            if (row.uomName) {
                if (row.uomName.toLowerCase().includes('lb')) conversionFactor = 0.454;
                else if (row.uomName.toLowerCase().includes('oz')) conversionFactor = 0.0283495;
                else if (row.uomName.toLowerCase().includes('gm')) conversionFactor = 0.001;
            }
    
            const match = row.packing_method_name ? row.packing_method_name.match(/(\d+)[X](\d+(\.\d+)?)/) : null;
            const pouchWeight = Number(row.pouchWeight) * conversionFactor;
            const grossWeight = Number(row.grossWeight);
            const pouchesPerCase = match ? Number(match[1]) : 1;
    
            const slabsFromCases = Number(row.cases) * pouchesPerCase;
            const slabsFromLoosePouches = Number(row.loosePouches) || 0;
            const totalSlabsForRow = slabsFromCases + slabsFromLoosePouches;
    
            const totalKgsForRow = totalSlabsForRow * pouchWeight;
            const totalGrossKgsForRow = totalSlabsForRow * grossWeight;
    
            totalSlabs += totalSlabsForRow;
            totalKgs += totalKgsForRow;
            totalGrossWeight += totalGrossKgsForRow;
    
            // console.log(totalSlabsForRow, "Total Slabs for Row");
            // console.log(totalSlabs, "Cumulative Total Slabs");
    
            let convertedShortCode;
            if (!row.valueFiveCode || row.valueFiveCode === "GII") {
                // Split short_code when valueFiveCode is null or "GII"
                convertedShortCode = `${row.short_code?.split('-')?.slice(0, 2)?.join('-')} ${Number(row.pouchWeight)} ${row.uomName}`;
            } else {
                // Keep short_code unchanged when valueFiveCode is not null and not "GII"
                convertedShortCode = `${row.short_code}${" "} ${Number(row.pouchWeight)} ${row.uomName}`;
            }
        
            return {
                slabs: totalSlabsForRow,
                noOfKgs: Number(totalKgsForRow.toFixed(3)),
                convertedShortCode,
                grossWeight,
                grossWeightPerKg: Number(totalGrossKgsForRow.toFixed(3)),
            };
        });
    
        const aggregatedData = Object.values(processedData.reduce((acc: any, row: any) => {
            if (acc[row.convertedShortCode]) {
                acc[row.convertedShortCode].slabs += row.slabs;
                acc[row.convertedShortCode].noOfKgs += row.noOfKgs;
                acc[row.convertedShortCode].grossWeightPerKg += row.grossWeightPerKg;
            } else {
                acc[row.convertedShortCode] = { ...row };
            }
            return acc;
        }, {}));
    
        const finalData = aggregatedData.map((row: any) => ({
            ...row,
            noOfKgs: Number(row.noOfKgs.toFixed(3)),
            grossWeightPerKg: Number(row.grossWeightPerKg.toFixed(3)),
        }));
    
        // console.log(totalSlabs, "Final Total Slabs");
        console.log(finalData)
        let namesData:any = [];
        let netWeightInKgs:any = [];
        let grossWeightInKgs:any = [];
        let slab:any = [];
        let grossWeight:any = [];

        for(let ds of finalData){
            console.log("finalData loop")
            console.log(ds)
            namesData.push(ds.convertedShortCode)
            netWeightInKgs.push(ds.noOfKgs)
            grossWeightInKgs.push(ds.grossWeightPerKg)
            slab.push(ds.slabs)
            grossWeight.push(ds.grossWeight)

        }
    
        return new CommonResponse(true, 1, "Production Data Retrieved Successfully", [{"category":namesData},{"slab":slab},{"grossWeight":grossWeight},{"netWeightInKgs":netWeightInKgs},{"grossWeightInKgs":grossWeightInKgs}]);
    }
    
    async getClosingStock():Promise<CommonResponse>{
        try{
            const manager = getManager()
                let query1 = `SELECT SUM(cartons) AS ClosingStock FROM ${appSettings.analytics_db}.daywise_opening_stock s where date(date) = Date(Now())`;
                const result =await manager.query(query1);

            if(result.length > 0){
                return new CommonResponse(true,1,'Data retreievd',result)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }

    }

    async getDeadStock():Promise<CommonResponse>{
        try{
            const manager = getManager()
                let skus = `Select sk.sku_code_id AS skuCodeId,sk.short_code AS shortCode from ${appSettings.warehouse_db}.reporting r left join ${appSettings.masters_db}.sku_codes sk on sk.sku_code_id = r.variant_id group by r.variant_id order by sk.short_code`
                // let skus = `Select sku_code_id AS skuCodeId,short_code AS shortCode from ${appSettings.masters_db}.sku_codes where is_active = true`;
                const skuCodes =await manager.query(skus);

                console.log(skuCodes);
                let response:any = [];

                for(let code of skuCodes){

                    console.log("code")
                    console.log(code)

                    let query1 = `SELECT sk.short_code AS skuCode,reporting_date,s.varient_id,(s.total_cartons*pm.no_of_pouches*pm.pouches_per_row) AS qty FROM ${appSettings.warehouse_db}.reporting r LEFT JOIN ${appSettings.warehouse_db}.stock s ON s.stock_id = r.stock_id LEFT JOIN ${appSettings.masters_db}.sku_codes sk ON sk.sku_code_id = s.varient_id left join ${appSettings.masters_db}.packing_methods pm on pm.packing_method_id = s.pack_style_id WHERE r.variant_id = ${code.skuCodeId} and DATE(r.reporting_date) between DATE(NOW()) - INTERVAL 60 DAY AND DATE(NOW()) - INTERVAL 30 DAY and s.total_cartons > 0 AND s.status = 'StockIn' `;
                    const thirtyTo60daysresult =await manager.query(query1);
                    console.log("thirtyTo60daysresult")
                    console.log(thirtyTo60daysresult)
                    let query2 = `SELECT sk.short_code AS skuCode,reporting_date,s.varient_id,(s.total_cartons*pm.no_of_pouches*pm.pouches_per_row) AS qty FROM ${appSettings.warehouse_db}.reporting r LEFT JOIN ${appSettings.warehouse_db}.stock s ON s.stock_id = r.stock_id LEFT JOIN ${appSettings.masters_db}.sku_codes sk ON sk.sku_code_id = s.varient_id left join ${appSettings.masters_db}.packing_methods pm on pm.packing_method_id = s.pack_style_id WHERE r.variant_id = ${code.skuCodeId} and  DATE(r.reporting_date) between DATE(NOW()) - INTERVAL 90 DAY AND DATE(NOW()) - INTERVAL 60 DAY AND s.total_cartons > 0 AND s.status = 'StockIn' `;
                    const sixtyTo90daysresult =await manager.query(query2);
                    console.log("sixtyTo90daysresult")
                    console.log(sixtyTo90daysresult)
                    let query3 = `SELECT sk.short_code AS skuCode,reporting_date,s.varient_id,(s.total_cartons*pm.no_of_pouches*pm.pouches_per_row) AS qty FROM ${appSettings.warehouse_db}.reporting r LEFT JOIN ${appSettings.warehouse_db}.stock s ON s.stock_id = r.stock_id LEFT JOIN ${appSettings.masters_db}.sku_codes sk ON sk.sku_code_id = s.varient_id left join ${appSettings.masters_db}.packing_methods pm on pm.packing_method_id = s.pack_style_id WHERE r.variant_id = ${code.skuCodeId} and  DATE(r.reporting_date) between DATE(NOW()) - INTERVAL 120 DAY AND DATE(NOW()) - INTERVAL 90 DAY AND s.total_cartons > 0 AND s.status = 'StockIn' `;
                    const ninetyTo120daysresult =await manager.query(query3);
                    console.log("ninetyTo120daysresult")
                    console.log(ninetyTo120daysresult)

                    response.push({"variety":code.shortCode,"thirtyTo60":thirtyTo60daysresult.length>0?thirtyTo60daysresult[0].qty:0,"sixtyTo90":sixtyTo90daysresult.length>0?sixtyTo90daysresult[0].qty:0,"ninetyTo120":ninetyTo120daysresult.length>0?ninetyTo120daysresult[0].qty:0})
                }

                const filteredData = response.filter(item =>
                    item.thirtyTo60 !== 0 || item.sixtyTo90 !== 0 || item.ninetyTo120 !== 0
                );

                return new CommonResponse(true,1,'Data retreievd',filteredData)
        }catch(err){
            throw err
        }
    }


    async getSoakingDataForProductionReport(req?: ProductionProcessDashboardReq): Promise<CommonResponse> {
        const manager = getManager();
        req.date = moment(req.date).format('YYYY-MM-DD');
        let query = `SELECT  pl.production_log_id AS production_log_id,DATE(pl.date) AS createdAt,CONCAT(SUBSTRING(pl.product, 1, LENGTH(pl.product) - LOCATE('-', REVERSE(pl.product)))) AS product,
                    SUM(IF(pl.operation = 'SOAKING' AND DATE(pl.date) = '${req.date}', pl.input_quantity, 0)) AS inputQuantity,
                    SUM(IF(pl.operation = 'PACKING', pl.actual_output_quantity, 0)) AS actualOutputQuantity
                    FROM  ${appSettings.production_db} .production_log pl
                    LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.short_code = pl.product
                    WHERE  pl.operation IN ('SOAKING', 'PACKING')
                    GROUP BY DATE(pl.date),sku.food_type_id,sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,sku.value_addition_four_id,sku.value_addition_five_id,sku.soaking_style
                    HAVING  inputQuantity > 0`
        const data = await manager.query(query)
        let yieldPercentage:any = [];
        let product:any = [];
        let productionInKgs:any = [];
        let soakInKgs:any = [];

        for(let dr of data){
            let val = 0
            if(dr.inputQuantity === 0 || dr.actualOutputQuantity === 0){
                val = -100;
            }
            else{
                val = ((dr.actualOutputQuantity / dr.inputQuantity) * 100) - 100;
            }
            yieldPercentage.push(val)
            product.push(dr.product)
            productionInKgs.push(dr.actualOutputQuantity)
            soakInKgs.push(dr.inputQuantity)

        }
        if (data) {
            return new CommonResponse(true, 1, "Soaking Details Retrieved Successfully", [{"yieldPer":yieldPercentage},{"product":product},{"soakInKgs":soakInKgs},{"productionInKgs":productionInKgs}])
        } else {
            return new CommonResponse(false, 0, "No Data Found", [])
        }
    }

    async getYieldProductionReport(req?: ProductionProcessDashboardReq): Promise<CommonResponse> {
        const manager = getManager();
        req.date = moment(req.date).format('YYYY-MM-DD');

        const lotCodeDataQuery = `
            SELECT 
                SUM(l.quantity) AS grnHonQuantity, 
                l.sample_yield AS sampleYield, 
                CASE 
                    WHEN l.lot_club_status = 1 THEN l.clubbed_main_lot 
                    ELSE l.lot_number 
                END AS lot_group
            FROM erpx_dev_production.lot_code_data l
            GROUP BY lot_group
        `;

        const lotCodeData = await manager.query(lotCodeDataQuery);

        const lotGroupMap = new Map();
        lotCodeData.forEach(row => {
            lotGroupMap.set(row.lot_group, row.grnHonQuantity);
        });

        const productionLogQuery = `
            SELECT 
                pl.shift, 
                pl.lot_number AS lotNumber, 
                pl.input_grade AS grnHonCount,
                SUM(IF(pl.operation = 'DEHEADING', pl.actual_output_quantity, 0)) AS actualOutputQuantity,
                SUM(IF(pl.operation = 'GRADING' AND pl.date = '${req.date}', pl.actual_output_quantity, 0)) AS quantity,
                l.sample_yield AS sampleYield
            FROM erpx_dev_production.production_log pl
            LEFT JOIN erpx_dev_production.lot_code_data l 
                ON l.lot_number = pl.lot_number AND l.count = pl.input_grade
            WHERE pl.operation IN ('DEHEADING', 'GRADING')
            GROUP BY pl.lot_number, pl.input_grade
            HAVING quantity > 0
        `;

        const productionLogData = await manager.query(productionLogQuery);

        const result = productionLogData.map(row => ({
            ...row,
            grnHonQuantity: lotGroupMap.get(row.lotNumber) || 0
        }));

        let code:any=[]
        let count:any=[]
        let sampleYield:any=[]
        let yieldPer:any=[]
        let honQty:any=[]
        let grading:any=[]
        let deheading:any=[]
        let totalHONqty = 0
        for(let rs of result){
          const yieldPerc = rs.grnHonQuantity ? ((rs.quantity / rs.grnHonQuantity) * 100).toFixed(2) : '-';
            // count.push(rs.grnHonCount);
            code.push(rs.lotNumber +" - "+rs.grnHonCount);
            honQty.push(rs.grnHonQuantity);
            grading.push(rs.quantity);
            deheading.push(rs.actualOutputQuantity);
            sampleYield.push(rs.sampleYield);
            yieldPer.push(yieldPerc);
            totalHONqty = Number(totalHONqty) + Number(rs.grnHonQuantity);
        }
        if (result.length > 0) {
            return new CommonResponse(true, 1, "Shift Wise Data Retrieved Successfully", [{"Lot No":code},{"HON COUNT":count},{"HON QNT":honQty},{"GRADEING HLSO QNT":grading},{"YIELD PER":yieldPer},{"SAMPLE YIELD":sampleYield},{"DE HEADING HLSO QTY":deheading},{"Total HON Qty":totalHONqty}]);
        } else {
            return new CommonResponse(false, 0, "No Data Found", []);
        }
    }

    async getAntibioticTestResult():Promise<CommonResponse>{
        try{
            const manager = getManager()
                let testquery = `Select sf.code,sf.name,GROUP_CONCAT(gi.quantity) AS quantities from ${appSettings.rm_procure_db}.grn_items gi left join ${appSettings.masters_db}.suppliers sf on sf.supplier_id = gi.farmer where farmer > 0 and antibiotics_test_status = "COMPLETED" and test_result = "FAIL" group by farmer`
                const testResult =await manager.query(testquery);
                console.log(testResult);
                return new CommonResponse(true,1,'Data retreievd',testResult)
        }catch(err){
            throw err
        }
    }

    async getTodayArrivalQty():Promise<CommonResponse>{
        try{
            const manager = getManager()
                let testquery = `Select ii.expected_count AS count,SUM(ii.expected_qty) AS qty from ${appSettings.rm_procure_db}.indent_items ii left join  ${appSettings.rm_procure_db}.indent i on i.indent_id = ii.indent_id where Date(i.harvesting_date) between Date(now()) -INTERVAL 2 DAY and Date(now()) group by ii.expected_count order by ii.expected_count`;
                const testResult =await manager.query(testquery);
                console.log(testResult);
                return new CommonResponse(true,1,'Data retreievd',testResult)
        }catch(err){
            throw err
        }
    }

    async getSaleOrdersData(req: DateRangeReq):Promise<CommonResponse>{
        try{
            const manager = getManager();
            let query = `
            SELECT
                (SELECT COUNT(sale_order_id)
                FROM  ${appSettings.sales_db}.so_invoice_details) AS totalOrders,

                (SELECT COUNT(sale_order_id)
                FROM ${appSettings.sales_db}.so_invoice_details
                WHERE DATE_FORMAT(act_edl_date, '%Y-%m') BETWEEN '${req.fromDate}' AND '${req.toDate}') AS totalOrdersInRange,

                (SELECT COUNT(sot.sale_order_id)
                FROM ${appSettings.sales_db}.sale_order_track sot
                LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id = sot.sale_order_id and ci.is_active =1
                WHERE sot.container_status = 'SHIPPED' AND DATE_FORMAT(ci.invoice_date, '%Y-%m') BETWEEN '${req.fromDate}' AND '${req.toDate}') AS totalShippedOrders,

                (SELECT COUNT(sid.sale_order_id)
                FROM ${appSettings.sales_db}.so_invoice_details sid
                LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id = sid.sale_order_id
                LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = sid.sale_order_id
                WHERE sot.container_status != 'SHIPPED' AND sot.so_status != 'CANCELLED' AND so.so_process_type = 'MTO' AND DATE_FORMAT(sid.act_edl_date, '%Y-%m') BETWEEN '${req.fromDate}' AND '${req.toDate}') AS totalPendingOrders,

                (SELECT COUNT(sid.sale_order_id)
                FROM ${appSettings.sales_db}.so_invoice_details sid
                LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id = sid.sale_order_id
                Left join ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = sid.sale_order_id
                WHERE so.status IN ('OPEN', 'INPROGRESS') AND DATE_FORMAT(sid.act_edl_date, '%Y-%m') < '${req.fromDate}' and sot.container_status != 'SHIPPED' and so.so_process_type!='MTS') AS totalOverdueOrders;`
            
            const data = await manager.query(query);

            if(data.length > 0){
                return new CommonResponse(true,1,'Data retrieved',data)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw(err)
        }
    }

    async getSaleOrdersDetailData(req: DateRangeReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const { fromDate, toDate, status } = req;
    
            const baseQuery = `
                SELECT 
                    sid.inv_details_id, sid.po_number AS poNo,
                    sid.sale_order_id AS saleOrderId, 
                    so.sale_order_no AS saleOrderNo, 
                    ec.end_customer_name AS customerName, 
                    co.country_name AS countryName,
                    so.status,
                    sid.act_edl_date AS etdDate,
                    TIMESTAMPDIFF(MONTH, sid.act_edl_date, CURRENT_DATE) AS agingMonths
                FROM ${appSettings.sales_db}.so_invoice_details sid
                LEFT JOIN ${appSettings.masters_db}.countries co ON co.country_id = sid.country_id
                LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = sid.end_customer_id
                LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id = sid.sale_order_id
            `;
    
            let whereClause = '';
            if (status === 'PENDING') {
                whereClause = `
                    LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = sid.sale_order_id
                    WHERE sot.container_status != 'SHIPPED' AND sot.so_status != 'CANCELLED' AND so.so_process_type = 'MTO' AND DATE_FORMAT(sid.act_edl_date, '%Y-%m') BETWEEN '${fromDate}' AND '${toDate}'`;
            } else if (status === 'OVERDUE') {
                whereClause = ` LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = sid.sale_order_id WHERE so.status IN ('OPEN', 'INPROGRESS') AND DATE_FORMAT(sid.act_edl_date, '%Y-%m') < '${fromDate}' and sot.container_status != 'SHIPPED'`;
            } else if (status === 'SHIPPED') {
                whereClause = `
                 LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id = sid.sale_order_id and ci.is_active =1
                    LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = sid.sale_order_id
                    WHERE sot.container_status = 'SHIPPED' AND DATE_FORMAT(ci.invoice_date, '%Y-%m') BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
            } else if (status === 'INRANGE') {
                whereClause = `WHERE DATE_FORMAT(sid.act_edl_date, '%Y-%m') BETWEEN '${fromDate}' AND '${toDate}'`;
            } else if(status === 'TOTAL'){
                whereClause =``
            }
    
            const finalQuery = `${baseQuery} ${whereClause} ORDER BY so.sale_order_no`;
            const data = await manager.query(finalQuery);
    
            return data.length > 0
                ? new CommonResponse(true, 1, 'Data retrieved', data)
                : new CommonResponse(false, 0, 'No data found');
        } catch (err) {
            throw err;
        }
    }

    async getRmReceivingReportSummary(req: RmReceivingDashReq): Promise<CommonResponse> {
        try {
          const manager = getManager();
          const today = moment();
          const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ];
      
          if (req.type === 'day') {
            const date = moment(req.grnDate);
            const formattedDate = date.format('YYYY-MM-DD');
            const targetMonth = date.month();
            const targetYear = date.year();
            const monthName = monthNames[targetMonth];
            const daysInMonth = date.daysInMonth();
      
            const query = `
              SELECT 
                r.count, 
                r.quantity/${daysInMonth} AS rmQty,
                0 AS opBal,
                SUM(CASE WHEN DATE(gi.reweighment_date) = '${formattedDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
                SUM(CASE WHEN DATE(gi.reweighment_date) = '${formattedDate}' THEN ri.quantity ELSE 0 END) AS total
              FROM 
                ${appSettings.masters_db}.rm_budget r
                LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON r.count = gi.budget_range
                LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri ON ri.grn_item_id = gi.grn_item_id 
              WHERE r.year = '${targetYear}' AND r.month = '${monthName}'
              GROUP BY r.count
            `;
      
            const results = await manager.query(query);
            const dates = [{ date: formattedDate }];
            return results.length
              ? new Response(true, 1, 'Data retrieved successfully', results, dates)
              : new Response(false, 0, 'No data found', [], []);
      
          } else {
            const [year, month] = req.grnDate.split('-').map(Number);
            const isCurrentMonth = today.year() === year && today.month() === month - 1;
            const endDate = isCurrentMonth ? today.clone() : moment({ year, month: month - 1 }).endOf('month');
      
            const startDate = moment({ year, month: month - 1, day: 1 });
            const formattedStart = startDate.format('YYYY-MM-DD');
            const formattedEnd = endDate.format('YYYY-MM-DD');
            const targetMonth = startDate.month();
            const targetYear = startDate.year();
            const monthName = monthNames[targetMonth];
      
            const dates = [];
            const nextDates = [];
      
            let current = startDate.clone();
            while (current.isSameOrBefore(endDate, 'day')) {
              const dateStr = current.format('YYYY-MM-DD');
              dates.push({ date: dateStr });
              nextDates.push(dateStr);
              current.add(1, 'day');
            }
      
            const dayCases = nextDates
              .map((date, i) =>
                `SUM(CASE WHEN DATE(gi.reweighment_date) = '${date}' THEN ri.quantity ELSE 0 END) AS day${i + 1}`
              ).join(', ');
      
            const opBalCondition = `
              SUM(CASE WHEN DATE(gi.reweighment_date) < '${formattedStart}' THEN ri.quantity ELSE 0 END)
            `;
      
            const query = `
              SELECT 
                r.count, 
                r.quantity AS rmQty,
                ${opBalCondition} AS opBal,
                ${dayCases},
                SUM(CASE WHEN DATE(gi.reweighment_date) = '${formattedEnd}' THEN ri.quantity ELSE 0 END) AS selectedDate,
                SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStart}' AND '${formattedEnd}' THEN ri.quantity ELSE 0 END) AS total
              FROM 
                ${appSettings.masters_db}.rm_budget r
                LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON r.count = gi.budget_range
                LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri ON ri.grn_item_id = gi.grn_item_id 
              WHERE r.year = '${targetYear}' AND r.month = '${monthName}'
              GROUP BY r.count
            `;
      
            const results = await manager.query(query);
            return results.length
              ? new Response(true, 1, 'Data retrieved successfully', results, dates)
              : new Response(false, 0, 'No data found', [], []);
          }
        } catch (err) {
          throw err;
        }
      }
       async getSupllierTypeWiseData():Promise<CommonResponse>{
    try{
                  const manager = getManager();

        let response :any[] =[]
        const today = new Date();
        const year = today.getFullYear();
      
      let smiplifiedQuery = `SELECT
    supplier_type,
    MONTH(g.grn_date) AS month,
    SUM(gi.quantity) AS totalQty
FROM 
    ${appSettings.rm_procure_db}.grn g
LEFT JOIN 
    ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_id = g.grn_id
WHERE 
    YEAR(g.grn_date) = '${year}'
GROUP BY 
    supplier_type, MONTH(g.grn_date)`
        const info = await manager.query(smiplifiedQuery)
  
        if(info.length > 0){
            for(const data of info){
                const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                // console.log(monthNames[data.month - 1],'monnnnnnnn');
                const monthName = monthNames[data.month - 1]; // Convert month number to month name
                response.push({xAxisValue: monthNames[data.month - 1],yAxisValue:Math.round(data.totalQty),type:data.supplier_type,xTitle:'Month',yTitle:'Procured Quantity'});
            }
            
            
            return new CommonResponse(true,1,'data retrieved',response)
        }else{
            return new CommonResponse(false,0,'No data found') 
        }
    }catch(err){
        throw err
    }
  }
    

}